import { useAuth } from '@/auth/useAuth';
import { Navigate } from 'react-router-dom';
import { EmpresaListPage } from '../empresas';
import { AccessDeniedPage } from './AccessDeniedPage';

export function HomePage() {
  const { user } = useAuth();
  const role = user?.asesor?.rol;

  if (role === 'SYSADMIN') {
    return <Navigate to="/admin" replace />;
  }

  if (role === 'ADMIN') {
    return <Navigate to="/dashboard" replace />;
  }

  return <div className="">{role === 'ASESOR' ? <EmpresaListPage /> : <AccessDeniedPage />}</div>;
}
